import { configureStore } from '@reduxjs/toolkit'
import {LoaderReducer} from "./LoaderReducer";

export default configureStore({
    reducer: {
        loader: LoaderReducer
    },
})